import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';
import { AuthenticationService } from 'app/core/authentication';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ManageEmailPreferencesService } from 'app/settings/manage-email-preferences/manage-email-preferences.service';
import { Router } from '@angular/router';
import { TEACHERS_ROUTE } from 'app/teachers/teachers-routing.constant';
import { TeacherSubscriptionService } from 'app/teachers/services/teacher-subscription.service';

import { UntilDestroy } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { TranslationService } from 'app/core/internationalization/translation.service';

@UntilDestroy()
@Component({
    selector: 'kh-cancel-subscription-modal',
    styleUrls: ['./cancel-subscription-modal.component.less'],
    templateUrl: './cancel-subscription-modal.component.html',
    standalone: false
})
export class CancelSubscriptionModalComponent {
  public emailGroupsForm!: FormGroup;

  public constructor(
    protected readonly bsModalRef: BsModalRef,
    protected readonly translationService: TranslationService,
    protected readonly formBuilder: FormBuilder,
    protected readonly accountSettingsDataService: AccountSettingsDataService,
    protected readonly authenticationService: AuthenticationService,
    protected readonly manageEmailPreferencesService: ManageEmailPreferencesService,
    private readonly router: Router,
    private readonly teacherSubscriptionService: TeacherSubscriptionService
  ) {}

  public onCancelSubscription(): void {
    this.bsModalRef.hide();

    this.teacherSubscriptionService
      .deleteTeacherPremiumSubscription()
      .pipe(
        tap(() => {
          this.router.navigate(TEACHERS_ROUTE.SUBSCRIBE.route());
        })
      )
      .subscribe();
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
